module.exports = __webpack_public_path__ + "img/loading.bc0f58f4.webp";